import React from 'react';
import config from '../../config/config';
import REST_API_NAMES from '../../config/restApiNames';
import axios from 'axios';
import { withRouter } from 'react-router';
import Modal from '../../components/common/Modal/Modal';
import { Grid } from 'react-bootstrap';
import analyticsContext from '../../components/analytics/Analytics';
import { getAndSetCampaignDetails } from '../../util/ApiUtil';
import { applyRequiredCapitalizations } from '../../util/TextUtils';
import { theme } from '../../../../themes';
import getPartnerAsset, { DynamicAssetsKeys } from '../../../../assets';

// Sample development url : http://localhost:3000/expert-sessions/email/unsubscribe

class Unsubscribe extends React.Component {
  state = { isSubmitted: false };

  componentDidMount() {
    this.messageId = this.props.location.hash.replace('#', '');
    if (this.messageId) {
      getAndSetCampaignDetails(this.messageId, this.sendReportingEventOnLoad);
    }
  }

  sendReportingEventOnLoad() {
    analyticsContext.withAdvancedProps({ section: 'unsubscribe' }).screenEvent();
  }

  unsubscribeHandler = () => {
    axios.post(config.REST_URL(REST_API_NAMES.unsubscribe), { id: this.messageId });
    this.setState({ isSubmitted: true });
    analyticsContext.withAdvancedProps({ action: 'unsubscribe' }).controlEvent();
  };

  cancelHandler = () => {
    const path = getPartnerAsset(DynamicAssetsKeys.expertSessionsPath);
    this.props.history.push(path);
  };

  renderForm = () => {
    return (
      <div className="unsubscribeForm">
        <div className="title">We'll miss you, but we understand</div>
        <div className="subtitle">
          By selecting the 'Unsubscribe Me' button below, you will be removed from our mailing list
        </div>
        <button
          className="btn inGreen unsubscribeButton"
          // style={{
          //   backgroundColor: theme.colors.primaryAccent,
          //   borderColor: theme.colors.primaryAccent,
          // }}
          onClick={this.unsubscribeHandler}
        >
          {applyRequiredCapitalizations('Unsubscribe Me')}
        </button>
        <br />
        <a
          className="btn noBorderGreen cancelLink"
          // style={{ color: theme.colors.primaryAccentOnWhite }}
          onClick={this.cancelHandler}
        >
          {applyRequiredCapitalizations('CANCEL')}
        </a>
      </div>
    );
  };

  renderSuccessForm = () => {
    return (
      <div className="unsubscribeSuccessForm">
        <div className="title">You have been removed from our mailing list</div>
        <button className="btn inGreen okayBtn" onClick={this.cancelHandler}>
          Okay
        </button>
      </div>
    );
  };

  render() {
    return (
      <div className="unsubscribeContainer">
        {this.state.isSubmitted && this.renderSuccessForm()}
        {!this.state.isSubmitted && this.renderForm()}
      </div>
    );
  }
}

export default withRouter(Unsubscribe);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/pages/Unsubscribe/Unsubscribe.js